import { executeSingleExport, runExportFlow, getFileTimestamp } from 'utils/importExport/bulkExport'
import { isCsvExportableRecord } from 'utils/importExport/csvExport'
import { isMemoRecord } from 'pages/records/components/MemoEditorModal/memoRecord'
import exportStyles from '@/utils/importExport/style.module.scss'

const useRecordExport = (
  individual,
  { t, messageApi, setExportLoading, allowFileDownload = true },
) => {
  const handleExport = () => {
    const safeTitle = individual.title.replace(/[^a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ_-]/g, '_')
    runExportFlow({
      defaultFilename: `${safeTitle}_${getFileTimestamp()}`,
      t,
      styles: exportStyles,
      messageApi,
      // 확인·경고 팝업 문구를 "비밀번호" 대신 "메모"로 (상세 응답은 is_memo 또는 template.icon 으로 판별)
      isMemo: isMemoRecord(individual),
      // 메모 판정 신호(아이콘·rich_note 항목) 중 하나라도 메모면 CSV 선택지를 숨긴다 — 헷갈리면 숨기는 쪽이 안전하다(JSON 은 그대로 가능, spec D10)
      csvAllowed: !isMemoRecord(individual) && isCsvExportableRecord(individual),
      onExecute: ({ filename, password, onDestroyParentModals, format }) =>
        executeSingleExport({
          individual,
          filename,
          password,
          t,
          messageApi,
          setExportLoading,
          allowFileDownload,
          onDestroyParentModals,
          format,
        }),
    })
  }

  return { handleExport }
}

export default useRecordExport
